import api from '../utils/api';
import DispatchConstants from '../constants/DispatchConstants';
import EmailVerification from '../model/EmailVerification';

import { logError } from '@zg-rentals/log-error';

const EmailVerificationActions = {
  getUnverifiedEmailFeedListings(limit) {
    const data = {};

    if (limit) {
      data.limit = limit;
    }

    return (dispatch) =>
      dispatch(api.users.emailVerification.unverifiedEmailFeedListings(data)).then((response) => {
        if (response.success && response.response) {
          const emailVerificationModel = EmailVerification(response.response);

          dispatch(EmailVerificationActions.updateEmailVerificationInfo(emailVerificationModel));
          return emailVerificationModel;
        }
        return Promise.reject(response.error);
      });
  },
  /**
   * typeof data: {
   *   emailVerificationType: 'accountEmailClaimListings' | 'listingClaimingFlow';
   *   successRedirectPath?: string;
   *   successRedirectLocation?: string;
   *   email?: string;
   * }
   **/
  sendSecurityToken(data) {
    return (dispatch) =>
      dispatch(api.users.emailVerification.sendSecurityToken(data))
        .then((response) => {
          if (response.success && response.response) {
            return response;
          }
          return Promise.reject(response.error);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'EmailVerificationActions.sendSecurityToken',
          });
        });
  },
  verifySecurityToken(token) {
    return (dispatch) =>
      dispatch(api.users.emailVerification.verifySecurityToken(token))
        .then((response) => {
          if (response.success) {
            return response;
          }
          return Promise.reject(response);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'EmailVerificationActions.verifySecurityToken',
          });
          return Promise.reject(errorRMWModel.error);
        });
  },
  updateEmailVerificationInfo(data) {
    return (dispatch) =>
      dispatch({
        type: DispatchConstants.UPDATE_EMAIL_VERIFICATION,
        payload: data,
      });
  },
};

export default EmailVerificationActions;
